
export const menuData = {
  coffee: [
    { name: 'Espresso', price: '£2.80' },
    { name: 'Double Espresso', price: '£3.20' },
    { name: 'Americano', price: '£3.00' },
    { name: 'Flat White', price: '£3.40' },
    { name: 'Cappuccino', price: '£3.40' },
    { name: 'Latte', price: '£3.40' },
    { name: 'Mocha', price: '£3.80' },
    { name: 'Hot Chocolate', price: '£3.50' },
    { name: 'Tea (Selection)', price: '£2.60' },
    { name: 'Iced Coffee', price: '£3.60' },
  ],
  breakfast: [
    { name: 'Full English Breakfast', description: 'Eggs, bacon, sausage, mushrooms, tomatoes, beans, toast', price: '£8.95' },
    { name: 'Vegetarian Breakfast', description: 'Eggs, veggie sausages, mushrooms, tomatoes, beans, toast', price: '£8.50' },
    { name: 'Eggs on Toast', description: 'Two eggs your way on toasted bread', price: '£5.50' },
    { name: 'Smashed Avocado on Toast', description: 'Fresh avocado, poached eggs, chilli flakes', price: '£7.50' },
    { name: 'Bacon Sandwich', description: 'Crispy bacon in fresh bread or toast', price: '£4.95' },
    { name: 'Sausage Sandwich', description: 'Local sausages in fresh bread or toast', price: '£4.95' },
    { name: 'Porridge', description: 'Creamy oats with honey and fresh fruit', price: '£4.50' },
    { name: 'Toasted Teacake', description: 'With butter and jam', price: '£3.20' },
  ],
  lunch: [
    { name: 'Soup of the Day', description: 'Served with fresh bread and butter', price: '£5.95' },
    { name: 'Cheese & Ham Toastie', description: 'Mature cheddar and local ham', price: '£6.50' },
    { name: 'Tuna Melt', description: 'Tuna mayo with melted cheese', price: '£6.50' },
    { name: 'BLT Sandwich', description: 'Bacon, lettuce, tomato on your choice of bread', price: '£6.95' },
    { name: 'Ploughman\'s Lunch', description: 'Cheddar, pickle, salad, crusty bread', price: '£7.95' },
    { name: 'Jacket Potato', description: 'Choice of fillings: cheese, beans, tuna mayo, or coleslaw', price: '£6.50' },
    { name: 'Quiche of the Day', description: 'Served with salad and coleslaw', price: '£7.50' },
    { name: 'Panini (Various)', description: 'Ask staff for today\'s options', price: '£6.95' },
  ],
  cakes: [
    { name: 'Victoria Sponge', description: 'Classic jam and cream cake', price: '£3.50' },
    { name: 'Carrot Cake', description: 'With cream cheese frosting', price: '£3.80' },
    { name: 'Chocolate Fudge Cake', description: 'Rich and indulgent', price: '£3.80' },
    { name: 'Lemon Drizzle Cake', description: 'Zesty and moist', price: '£3.50' },
    { name: 'Brownie', description: 'Chewy chocolate brownie', price: '£3.20' },
    { name: 'Scone', description: 'With jam and clotted cream', price: '£3.50' },
    { name: 'Fruit Tart', description: 'Fresh seasonal fruit', price: '£3.80' },
    { name: 'Biscuit Selection', description: 'Freshly baked daily', price: '£1.50' },
  ],
};
